import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ArticleIcon from "@mui/icons-material/Article";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BallotIcon from "@mui/icons-material/Ballot";
import BarChartIcon from "@mui/icons-material/BarChart";
import BugReportIcon from "@mui/icons-material/BugReport";
import BuildIcon from "@mui/icons-material/Build";
import BusinessIcon from "@mui/icons-material/Business";
import CalculateIcon from "@mui/icons-material/Calculate";
import CasinoIcon from "@mui/icons-material/Casino";
import ChatIcon from "@mui/icons-material/Chat";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudIcon from "@mui/icons-material/Cloud";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import ConstructionIcon from "@mui/icons-material/Construction";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import CookieIcon from "@mui/icons-material/Cookie";
import DashboardIcon from "@mui/icons-material/Dashboard";
import DescriptionIcon from "@mui/icons-material/Description";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import DownloadIcon from "@mui/icons-material/Download";
import DraftsIcon from "@mui/icons-material/Drafts";
import EmailIcon from "@mui/icons-material/Email";
import ExtensionIcon from "@mui/icons-material/Extension";
import FactoryIcon from "@mui/icons-material/Factory";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import FlagIcon from "@mui/icons-material/Flag";
import FolderIcon from "@mui/icons-material/Folder";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import GroupIcon from "@mui/icons-material/Group";
import HandshakeIcon from "@mui/icons-material/Handshake";
import HistoryIcon from "@mui/icons-material/History";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import HowToVoteIcon from "@mui/icons-material/HowToVote";
import InsightsIcon from "@mui/icons-material/Insights";
import InventoryIcon from "@mui/icons-material/Inventory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import KeyIcon from "@mui/icons-material/Key";
import LinearScaleIcon from "@mui/icons-material/LinearScale";
import LinkIcon from "@mui/icons-material/Link";
import LocalPostOfficeIcon from "@mui/icons-material/LocalPostOffice";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LockIcon from "@mui/icons-material/Lock";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import PaidIcon from "@mui/icons-material/Paid";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PersonIcon from "@mui/icons-material/Person";
import PsychologyIcon from "@mui/icons-material/Psychology";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import RouterIcon from "@mui/icons-material/Router";
import SaveIcon from "@mui/icons-material/Save";
import SchoolIcon from "@mui/icons-material/School";
import ScienceIcon from "@mui/icons-material/Science";
import ScreenshotMonitorIcon from "@mui/icons-material/ScreenshotMonitor";
import SearchIcon from "@mui/icons-material/Search";
import SettingsIcon from "@mui/icons-material/Settings";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import SpeedIcon from "@mui/icons-material/Speed";
import StorageIcon from "@mui/icons-material/Storage";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import SyncIcon from "@mui/icons-material/Sync";
import TerminalIcon from "@mui/icons-material/Terminal";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import WorkIcon from "@mui/icons-material/Work";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import React from "react";
import { DOCS } from "../../api/docs/registry";

// IMPORTANT: When creating new React views, add them to the appropriate menu section below
// Menu sections organized by FUNCTION (items sorted alphabetically):
// - stats_menu: Read-only KPI dashboards and statistics
// - datamining_menu: Data collection, extraction metrics, bot stats
// - queues_menu: Queue management with actions (clear/purge/revoke)
// - database_menu: Database health and raw table viewers
// - llm_menu: LLM/ML tools, prompts, evaluations
// - debug_menu: Development tools, logs, debugging utilities
// - admin_menu: User management (staff only)

export type MenuItem = {
	title?: string;
	action?: string;
	children?: MenuItem[];
	icon?: React.ElementType;
	divider?: boolean;
	/** Drawn as a badge on the item's icon; omitted or 0 draws nothing. */
	badgeCount?: number;
};

// ============================================================================
// STATS & KPIs - Read-only dashboards and statistics
// ============================================================================
const stats_menu: MenuItem = {
	title: "Stats & KPIs",
	icon: TrendingUpIcon,
	children: [
		{ title: "Connect Stats", action: "/charts/connect_stats/", icon: LinkIcon },
		{ title: "Email Stats", action: "/charts/email_stats/", icon: EmailIcon },
		{ title: "Job Stats", action: "/charts/job_stats/", icon: WorkIcon },
		{ title: "KPIs", action: "/charts/kpis", icon: ShowChartIcon },
		{ title: "Pitch Stats", action: "/charts/pitch_stats/", icon: BarChartIcon },
		{ title: "Screening Stats", action: "/charts/thumb_stats/", icon: ThumbUpIcon },
		{ title: "Vote Stats", action: "/charts/vote_stats/", icon: HowToVoteIcon },
	],
};

// ============================================================================
// DATA MINING - Data collection and extraction metrics
// ============================================================================
const datamining_menu: MenuItem = {
	title: "Data Mining",
	icon: ConstructionIcon,
	children: [
		{
			title: "Bot Board",
			icon: DashboardIcon,
			action:
				"/charts/bot_board/" +
				"?emaildomain=team55438.testinator.com&" +
				"limit=10&" +
				"omit_errors=KILLED&" +
				"omit_errors=UNAVAILABLE&" +
				"omit_errors=ENTER_PHONE_NUMBER&" +
				"omit_errors=unknown+account&" +
				"omit_errors=wrong%20password&" +
				"ordering=created&" +
				"offset=0",
		},
		{ title: "Bot Stats", action: "/charts/bot_stats/", icon: SmartToyIcon },
		{
			title: "Botfactory Stats",
			action: "/charts/botfactory_stats/",
			icon: FactoryIcon,
		},
		{ title: "Git Stats", action: "/charts/git_stats/", icon: FolderIcon },
		{
			title: "Latest Extracted Persons",
			action: "/charts/latest-persons",
			icon: NewReleasesIcon,
		},
		{
			title: "Accounts",
			action: "/charts/accounts",
			icon: AccountCircleIcon,
		},
		{
			title: "Rotating Proxies",
			action: "/charts/rotating_proxies",
			icon: RouterIcon,
		},
		{
			title: "Third Party Usage",
			action: "/charts/third_party_usage/",
			icon: ExtensionIcon,
		},
		{
			title: "Userscraping Stats",
			action: "/charts/userscraping_stats/",
			icon: PeopleOutlineIcon,
		},
		{
			title: "Voyager Log Stats",
			action: "/charts/voyager-log-stats",
			icon: BarChartIcon,
		},
	],
};

// ============================================================================
// QUEUES - Queue management with actions (view, clear, purge)
// ============================================================================
const queues_menu: MenuItem = {
	title: "Queues",
	icon: LinearScaleIcon,
	children: [
		{
			title: "Celery Tasks",
			action: "/charts/celery_tasks?updateTimeInSeconds=10",
			icon: SettingsIcon,
		},
		{
			title: "ContactInfo TNG Queue",
			action: "/charts/contactinfo_tng_queue",
			icon: ContactMailIcon,
		},
		{
			title: "Get Profile Queue",
			action: "/charts/latest-get-profile-queue",
			icon: DownloadIcon,
		},
		{
			title: "GradeConnectQueues",
			action: "/charts/grade-connect-queues",
			icon: CalculateIcon,
		},
		{
			title: "InMail Cost Queue",
			action: "/charts/inmail_cost_queue",
			icon: AttachMoneyIcon,
		},
		{
			title: "Messenger Forecast",
			action: "/charts/insights?tab=queues&sent=false&error_isnull=true",
			icon: ChatIcon,
		},
		{
			title: "Postfix Delivery",
			action: "/charts/postfix_delivery_events",
			icon: LocalPostOfficeIcon,
		},
		{
			title: "SES Delivery",
			action: "/charts/ses_dashboard",
			icon: EmailIcon,
		},
		{
			title: "Send Invite Queue",
			action: "/charts/send_invite_queue",
			icon: ForwardToInboxIcon,
		},
	],
};

// ============================================================================
// DATABASE - Database health monitoring and raw table viewers
// ============================================================================
const database_menu: MenuItem = {
	title: "Database",
	icon: StorageIcon,
	children: [
		{ title: "Advisory Locks", action: "/charts/advisory_locks/", icon: LockIcon },
		{ title: "Database Load", action: "/charts/database_load/", icon: SyncIcon },
		{
			title: "Elasticsearch",
			action: "/charts/elasticsearch_status",
			icon: SearchIcon,
		},
		{ title: "Database Size", action: "/charts/database_size/", icon: SaveIcon },
		{
			title: "Hot Database Tables",
			action: "/charts/hot_database_tables/",
			icon: WhatshotIcon,
		},
		{ title: "Index Health", action: "/charts/index_health/", icon: ScienceIcon },
		{ title: "DB Backups", action: "/charts/db_backups", icon: CloudSyncIcon },
	],
};

// ============================================================================
// LLM & ML - Language models, ML tools, prompts, evaluations
// ============================================================================
const llm_menu: MenuItem = {
	title: "LLM & ML",
	icon: PsychologyIcon,
	children: [
		{
			title: "Assignment LLM Agreement",
			action: "/charts/assignment-llm-agreement",
			icon: HandshakeIcon,
		},
		{
			title: "Assignment LLM Skills",
			action: "/charts/assignment-llm-skills",
			icon: SchoolIcon,
		},
		{
			title: "Extractor Prompts",
			action: "/charts/extractor_prompts/",
			icon: ArticleIcon,
		},
		{
			title: "Human Operator Agreement",
			action: "/charts/human-operator-agreement/",
			icon: Diversity3Icon,
		},
		{ title: "LLM Batches", action: "/charts/llm_batches/", icon: InventoryIcon },
		{
			title: "Provider Batch Jobs",
			action: "/charts/provider_batch_jobs",
			icon: CloudSyncIcon,
		},
		{ title: "LLM Cache", action: "/charts/llm_cache", icon: Inventory2Icon },
		{
			title: "LLM Cache Stats",
			action: "/charts/llm-cache-stats",
			icon: BarChartIcon,
		},
		{
			title: "LLM Performance",
			action: "/charts/llm_performance/",
			icon: SpeedIcon,
		},
		{ title: "LLM Pricing", action: "/charts/llm_pricing", icon: PaidIcon },
		{
			title: "LLM Prompt Templates",
			action: "/charts/llm_templates/",
			icon: DescriptionIcon,
		},
		{ title: "ML Stats", action: "/charts/ml_stats/", icon: AutoGraphIcon },
		{
			title: "Vote Testsets",
			action: "/charts/vote_testsets/",
			icon: BallotIcon,
		},
	],
};

// ============================================================================
// DEBUG - Development tools, logs, debugging utilities
// ============================================================================
const debug_menu: MenuItem = {
	title: "Debug",
	icon: BuildIcon,
	children: [
		{
			title: "Locations",
			action: "/charts/assignment_locations",
			icon: LocationOnIcon,
		},
		{ title: "CV Browser", action: "/cv-browser", icon: StorageIcon },
		{ title: "User Integrations", action: "/charts/cookies", icon: CookieIcon },
		{ title: "Email Journal", action: "/charts/email_journal", icon: DraftsIcon },
		{ title: "Email sync", action: "/charts/email_sync", icon: CloudSyncIcon },
		{
			title: "Latest Voyager Logs",
			action: "/charts/latest-voyager-logs",
			icon: HistoryIcon,
		},
		{ title: "Lic Keys", action: "/charts/lic_keys", icon: KeyIcon },
		{ title: "Loki Logs", action: "/charts/loki_logs", icon: TerminalIcon },
		{
			title: "Plugin Work Logs",
			action: "/charts/plugin_work_log",
			icon: WorkHistoryIcon,
		},
		{
			title: "Pydoll Monitor",
			action: "/charts/pydoll-monitor",
			icon: ScreenshotMonitorIcon,
		},
		{
			title: "Captcha Monitor",
			action: "/charts/captcha-monitor",
			icon: ScreenshotMonitorIcon,
		},
		{ title: "Random Persons", action: "/charts/random-persons", icon: CasinoIcon },
		{
			title: "Runtime Error Test",
			action: "/dev/runtime-error",
			icon: BugReportIcon,
		},
		{
			title: "Screen Tiles",
			action: "/charts/screen_tiles",
			icon: ViewModuleIcon,
		},
		{
			title: "Theme Colors",
			action: "/charts/theme_colors",
			icon: ColorLensIcon,
		},
		{
			title: "Fingerprint Sessions",
			action: "/fingerprint-sessions",
			icon: FingerprintIcon,
		},
	],
};

// ============================================================================
// INSIGHTS - Available to everyone (non-superuser)
// ============================================================================
const insights_menu: MenuItem = {
	title: "Insights",
	action: "/charts/insights",
	icon: InsightsIcon,
};

// ============================================================================
// MENU ASSEMBLY
// ============================================================================
export const getMenuData = (
	currentUser: {
		is_staff: boolean;
		is_superuser: boolean;
		userprofile?: { email_method?: number };
	},
	/** Release notes published since this reader last opened the page. */
	unseenReleaseNotes = 0,
	/** This instance may pull data out of prod — never true on prod itself. */
	prodImportEnabled = false
): MenuItem[] => {
	const md: MenuItem[] = [
		{ title: "Todo", action: "/todo", icon: CheckCircleIcon },
		{ title: "Candidate Board", action: "/board/v2", icon: ViewKanbanIcon },
	];

	// Hosted-email recruiters get their own Email tab. Staff/admins also see
	// it so they can debug other email methods via the method tabs in the view.
	if (currentUser.userprofile?.email_method === 4 || currentUser.is_staff) {
		md.push({ title: "Email", action: "/email", icon: EmailIcon });
	}

	md.push({
		title: "Search",
		icon: SearchIcon,
		children: [
			{ title: "Companies", action: "/company_search", icon: BusinessIcon },
			{ title: "Persons", action: "/person_search", icon: PersonIcon },
		],
	});

	// Support — every signed-in user. Its badge (tickets with unseen writing
	// from the other side) is item-local async data the drawer fetches itself.
	md.push({
		title: "Support",
		action: "/support",
		icon: SupportAgentIcon,
	});

	// Admin menu for staff users
	if (currentUser.is_staff) {
		md.push({
			title: "Documentation",
			icon: MenuBookIcon,
			children: [
				{
					title: "Index",
					action: "/docs",
					icon: MenuBookIcon,
				},
				...DOCS.map((d) => ({
					title: d.title,
					action: `/docs/${d.slug}`,
					icon: ArticleIcon,
				})),
			],
		});
		md.push({
			title: "Technical Docs",
			action: "/tech-docs",
			icon: ArticleIcon,
		});
		md.push({
			title: "Release Notes",
			action: "/release-notes",
			icon: NewReleasesIcon,
			badgeCount: unseenReleaseNotes,
		});
		md.push({ title: "AI Lab", action: "/ai-lab", icon: PsychologyIcon });
		md.push({
			title: "Ticket Workflow",
			action: "/workflow",
			icon: AccountTreeIcon,
		});
		md.push({
			title: "Admin",
			icon: AdminPanelSettingsIcon,
			children: [
				{
					title: "Manage Users",
					action: "/user-management/active-users",
					icon: GroupIcon,
				},
				{
					title: "Customer Licences",
					action: "/user-management/customer-licenses",
					icon: WorkspacePremiumIcon,
				},
				{
					title: "Pending Users",
					action: "/user-management/pending-users",
					icon: HourglassEmptyIcon,
				},
				...(prodImportEnabled
					? [
							{
								title: "Import from PROD",
								action: "/prod_import",
								icon: CloudDownloadIcon,
							},
						]
					: []),
				{
					title: "Staging Deploy",
					action: "/staging-deploy",
					icon: RocketLaunchIcon,
				},
				{
					title: "Staging Overview",
					action: "/staging-overview",
					icon: CloudIcon,
				},
			],
		});
		md.push({ title: "OKR Dashboard", action: "/charts/okr/", icon: FlagIcon });
		md.push({
			title: "Roles",
			action: "/charts/assignments_overview",
			icon: HowToVoteIcon,
		});
		md.push({
			title: "Infra Costs",
			action: "/charts/infra_costs",
			icon: CloudIcon,
		});
	}

	// Insights available to everyone
	md.push(insights_menu);

	// Superuser menus - organized by function
	if (currentUser.is_superuser) {
		md.push(stats_menu);
		md.push(datamining_menu);
		md.push(queues_menu);
		md.push(database_menu);
		md.push(llm_menu);
		md.push(debug_menu);
	}

	return md;
};
